import { render, staticRenderFns } from "./cashback-purchase.vue?vue&type=template&id=751a6906&scoped=true&"
import script from "./cashback-purchase.vue?vue&type=script&lang=js&"
export * from "./cashback-purchase.vue?vue&type=script&lang=js&"
import style0 from "./cashback-purchase.vue?vue&type=style&index=0&id=751a6906&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "751a6906",
  null
  
)

export default component.exports